import { ColDef } from '@ag-grid-community/core';
import { AssetTypes } from '@tassat/common-definitions';
import { Asset } from '@tassat/fred-definitions';
import { formatAsAsset } from '@tassat/utility';

export const columnDefs: Array<ColDef> = ([
    {
        field: '',
        headerName: 'Asset',
        valueFormatter: ({ data }) => (data.asset as Asset).Type === AssetTypes.ASSET ?
            (data.asset as Asset).Ticker
            : (data.asset as Asset).Curcode,
        menuTabs: [],
        flex: 1
    },
    {
        field: 'stats.IsGoodStanding',
        headerName: 'Status',
        cellRenderer: 'standing',
        menuTabs: [],
        flex: 1
    },
    {
        field: 'stats.AvailablePosition',
        headerName: 'Available Balance',
        valueFormatter: ({ data }) => formatAsAsset(
            data.stats.AvailablePosition,
            data.asset,
            (data.asset as Asset).Type === AssetTypes.ASSET ? 'ticker' : 'symbol',
            undefined,
            (data.asset as Asset).Type === AssetTypes.ASSET ? true : false
        ),
        menuTabs: [],
        flex: 1
    }
]);